/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstSecretOpts, SchemaConstSecret, ISchemaConstSecret } from "../const/SchemaConstSecret";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueSecretOpts extends ISchemaValueOpts<ISchemaConstSecret>, ISchemaConstSecretOpts {}

/**
 * Schema: Secret value
 *
 * @param opts Schema options
 */
export function SchemaValueSecret(opts: ISchemaValueSecretOpts): ISchemaValue<ISchemaConstSecret> {

	return SchemaValue(SchemaConstSecret(opts), opts);

}
